import { render, staticRenderFns } from "./TeamTransfer.vue?vue&type=template&id=6d166940&scoped=true&"
import script from "./TeamTransfer.vue?vue&type=script&lang=js&"
export * from "./TeamTransfer.vue?vue&type=script&lang=js&"
import style0 from "./TeamTransfer.vue?vue&type=style&index=0&id=6d166940&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d166940",
  null
  
)

export default component.exports